import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { UsuarioAuthDataService } from '../services/usuario-auth-data.service';

export const notAllowedRolesGuard: CanActivateFn = () => {
  const router = inject(Router);
  const usuarioAuthDataService = inject(UsuarioAuthDataService);

  const user = usuarioAuthDataService.usuarioAuth();

  // No autenticado
  if (!user) {
    return router.parseUrl('/login');
  }

  const role = String(user.rol?.nombre ?? '').toUpperCase().trim();

  // ADMIN no puede entrar
  if (role === 'ROLE_ADMIN') {
    return router.parseUrl('/admin');
  }

  // MASTER_VALIDATOR no puede entrar
  if (role === 'ROLE_MASTER_VALIDATOR' || role === 'ROLE_MASTER_AGENT') {
    return router.parseUrl('/operational-management');
  }

  // resto sí
  return true;
};
